import React, { useEffect, useState } from "react";
import FocusAreas from "./FocusAreas";
import AnalystsReport from "./AnalystsReport";
import News from "./News";
import EarlyWarningSigns from "./EarlyWarningSigns";
import Signals from "./Signals";
import CustomChatbot from "./CustomChatbot";
import CustomTabPanel from "./TabPanel";
import { Tab, Tabs } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useClientContext } from "../context/ClientContext";
import { response } from "../assets/response";
import axiosInstance from "../utils/axios";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import AdsClickOutlinedIcon from "@mui/icons-material/AdsClickOutlined";
import { responseClientPulse } from "../assets/responseClientPulse";
import FinancialHealth from "./FinancialHealth";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLoading } from "../context/LoadingContext";

function ClientPulse() {
  const [value, setValue] = React.useState(0);
  const { clientName, clientGroup } = useClientContext();
  //const responseJson = responseClientPulse;
  const [responseJson, setResponseJson] = useState({});
  const [error, setError] = useState({});
  const bottomText = "Showing coverage from past 60 days";
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    // Fetch data when component mounts or when client selection changes
    fetchData();
  }, [clientName, clientGroup]); // Re-run effect when these values change

  const fetchData = async () => {
    try {
      showLoading();
      const response = await axiosInstance.post("/populate_dashboard", {
        client_id: clientGroup,
        subsidiary: clientName === "All" ? "" : clientName,
      });
      console.log("response", response.data);
      setResponseJson(response.data); // Handle successful response
    } catch (err) {
      setError("Error!!"); // Handle error
    } finally {
      hideLoading();
    }
  };

  //console.log('client name', clientName)

  return responseJson ? (
    <Grid container sx={{ height: "70vh", overflowY: "auto" }}>
      <Grid item size={12} m={1}>
        {/* Early Warning Signs */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <WarningAmberOutlinedIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">
                Early Warning Signs & Opportunities
              </h2>

              <div
                className="inline-block px-2 font-medium text-xs rounded-full"
                style={{ backgroundColor: "#00555C", color: "white" }}
              >
                NEW
              </div>
            </div>
            <Tooltip
              title="Insights into emerging risks (shown in red) and business opportunities (shown in green) for the client, enabling timely action for risk mitigation and identification of growth opportunities"
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <EarlyWarningSigns
              earlyWarning={responseJson.early_warning || []}
            />
            <div
              className="text-right text-xs"
              style={{ cursor: "pointer" }}
              onClick={() => {}}
            >
              <i>{bottomText}</i>
            </div>
          </AccordionDetails>
        </Accordion>

        {/* News */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <CampaignOutlinedIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">News Updates</h2>
              <div
                className="inline-block px-2 font-medium text-xs rounded-full"
                style={{ backgroundColor: "#00555C", color: "white" }}
              >
                NEW
              </div>
            </div>
            <Tooltip
              title="This section curates recent news articles, providing RMs with client-specific updates to enhance client conversations"
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <News news={responseJson.news || []} />
            <div
              className="text-right text-xs"
              style={{ cursor: "pointer" }}
              onClick={() => {}}
            >
              <i>{"Showing coverage from past 30 days"}</i>
            </div>
          </AccordionDetails>
        </Accordion>

        {/* Focus Areas */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <AdsClickOutlinedIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">Focus Areas</h2>
              <div
                className="inline-block px-2 font-medium text-xs rounded-full"
                style={{ backgroundColor: "#00555C", color: "white" }}
              >
                NEW
              </div>
            </div>
            <Tooltip
              title="Summarizes the Business Strategy and future goals of the Corporation"
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <FocusAreas focusAreas={responseJson.focus_area || []} />
          </AccordionDetails>
        </Accordion>
        {/* Signals */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <WifiOutlinedIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">
                Actionable Insights
              </h2>
            </div>
            <Tooltip
              title="Initiatives that BNI as a strategic partner can help its client in their growth"
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <Signals signals={responseJson.signals || []} />
          </AccordionDetails>
        </Accordion>
        {/* Analyst Reports */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <MenuBookOutlinedIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">Analyst Reports</h2>
            </div>
            <Tooltip
              title="Summarized expert evaluations and offers insights into financial analysis, products, business model, and future prospects of the client."
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <AnalystsReport analystReport={responseJson.analyst_report || []} />
          </AccordionDetails>
        </Accordion>
        {/* Financial Health */}
        <Accordion sx={{ marginBottom: "16px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex items-center gap-2">
              <MonitorHeartOutlinedIcon className="text-main" />
              <h2 className="text-xs font-bold text-main">Financial Health</h2>
            </div>
            <Tooltip
              title="Assesses client's stability and performance using key financial metrics"
              arrow
            >
              <InfoOutlinedIcon className="ml-2 text-main" fontSize="4px" />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails>
            <FinancialHealth
              financialHealth={responseJson.financial_health || []}
            />
          </AccordionDetails>
        </Accordion>
        
      </Grid>
    </Grid>
  ) : null;
}

export default ClientPulse;

// Card version
{
  /* <Grid size={3}>
                <div >
                    <FocusAreas focusAreas={responseJson[clientName]?.focus_area || []} />
                </div>
                <div >
                    <AnalystsReport analystReport={responseJson[clientName]?.analyst_report || []} />
                </div>
            </Grid>
            <Grid size={3}>
                <div>
                    <News news={responseJson[clientName]?.news || []} />
                </div>
                <div>
                    <EarlyWarningSigns earlyWarning={responseJson[clientName]?.early_warning || []} />
                </div>
            </Grid>
            <Grid size={3}>
                <Signals signals={responseJson[clientName]?.signals || []} />
            </Grid> */
}

// tab version

{
  /* <div>
<Tabs value={value} onChange={handleChange} aria-label="basic tabs">
    <Tab label="News" {...a11yProps(0)} sx={{ fontWeight: '700', fontSize: '18px' }} />
    <Tab label="Early Warning Signs" {...a11yProps(1)} sx={{ fontWeight: '700', fontSize: '18px' }} />
    <Tab label="Signals" {...a11yProps(2)} sx={{ fontWeight: '700', fontSize: '18px' }} />
</Tabs>
<CustomTabPanel value={value} index={0}>
    <News news={responseJson[clientName].news}/>
</CustomTabPanel>
<CustomTabPanel value={value} index={1}>
    <EarlyWarningSigns earlyWarning={responseJson[clientName].early_warning}/>
</CustomTabPanel>
<CustomTabPanel value={value} index={2}>
    <Signals signals={responseJson[clientName].signals}/>
</CustomTabPanel>
</div> */
}
